export default "__VITE_ASSET__s6b_nEvo__"